export default __webpack_public_path__ + "static/media/circleStreak-default.cefa23d8.png";